import { result } from 'lodash-es'
import dayjs from '@/utils/dayjs'
import axios from 'axios'

import { IActivity, IGetAllowedDates } from '@/store/modules/activity'
import { ITimeSlot, IVacancies } from '@/store/modules/timeslot'
import { IBookingConfirmation, IHoldBooking, IHoldBookings } from '@/store/modules/booking'
import store from '@/store'
import { ICapacity, IFacility, IFacilitySlot } from '@/store/modules/facility'

export async function getActivities(sku?: string): Promise<IFacility[]> {
    const params: IActivity = { query: JSON.stringify({ name: sku ?? store.getters.getSku })}
    const { data } = await axios.get('/integrations/facilities/activities', {
        headers: {
            'api-key': store.getters.apiKey
        },
        params
    })
    return typeof data !== 'string' ? data : []
}

export async function getProductId(payload?: { activities: IFacility[] }): Promise<string> {
    let activities = payload?.activities ?? store.getters.activities

    if (!activities || activities.length === 0) {
        await store.dispatch('loadActivities')
        activities = store.getters.activities
    }

    return result(activities[0], '_id')
}

export async function getVacancies(facilityId: string, date: string): Promise<IVacancies[]> {
    const params: IActivity = { query: JSON.stringify({ _id: facilityId, dateBooking: date }) }
    const { data } = await axios.get('/integrations/facilities/activities', {
        headers: {
            'api-key': store.getters.apiKey
        },
        params
    })
    return typeof data !== 'string' ? data : []
}

export async function getTimeSlots(date: string): Promise<ITimeSlot[]> {
    const facilityId = await getProductId()
    const vacancies = await getVacancies(facilityId, date)

    let activities = store.getters.activities

    if (!activities || activities.length === 0) {
        await store.dispatch('loadActivities')
        activities = store.getters.activities
    }
    const data = activities[0]
    let isAllDayTicket = false

    //checking if it is an all day ticket
    const currentDay = (dayjs(date)).day()
    const slots = data.settings.slots.filter((slot: IFacilitySlot) => {
        if (currentDay === 0) {
            return slot.day === 7
        } else {
            return slot.day === currentDay
        }
    })
    for (const slot of slots) {
        if (slot.start === '0000' && slot.end === '0000') {
            isAllDayTicket = true
            break
        }
    }

    const timeslots: ITimeSlot[] = []

    const name: string = data.name
    const today = new Date()
    if (date === today.toISOString().slice(0, 10) && !isAllDayTicket) {
        for (let j = 0; j < data.settings.slots.length; j++) {
            let capacity = ''
            if (data.settings.slots[j].capacity.length === 0) {
                capacity = data.settings.slotCapacity
            } else {
                const capacityHistory = data.settings.slots[j].capacity
                capacity = capacityHistory[capacityHistory.length - 1].capacity
            }

            const start: string = data.settings.slots[j].start
            const startTime = start.slice(0, 2) + ':' + start.slice(2, 4) + ':00'
            const end: string = data.settings.slots[j].end
            const endTime = end.slice(0, 2) + ':' + end.slice(2, 4) + ':00'
            const timeNow = today.toTimeString()
            let vacancy = 0
            for (const vac of vacancies) {
                if (data.settings.slots[j]._id === vac._idSlot) {
                    vacancy = vac.maxPax
                }
            }
            if ((startTime > timeNow || endTime > timeNow) && vacancy !== 0) {
                timeslots.push({
                    facilityName: name,
                    facilityId: facilityId,
                    slotId: data.settings.slots[j]._id,
                    start: data.settings.slots[j].start,
                    end: data.settings.slots[j].end,
                    maxCapacity: capacity,
                    vacancies: vacancy,
                    isActive: data.settings.slots[j].isActive,
                    name: data.settings.slots[j]?.name,
                })
            }
        }
    } else {
        for (let j = 0; j < data.settings.slots.length; j++) {
            let capacity = ''
            if (data.settings.slots[j].capacity.length === 0) {
                capacity = data.settings.slotCapacity
            } else {
                const capacityHistory = data.settings.slots[j].capacity
                capacity = capacityHistory[capacityHistory.length - 1].capacity
            }

            let vacancy = 0
            for (const vac of vacancies) {
                if (data.settings.slots[j]._id === vac._idSlot) {
                    vacancy = vac.maxPax
                    timeslots.push({
                        facilityName: name,
                        facilityId: facilityId,
                        slotId: data.settings.slots[j]._id,
                        start: data.settings.slots[j].start,
                        end: data.settings.slots[j].end,
                        maxCapacity: capacity,
                        vacancies: vacancy,
                        isActive:data.settings.slots[j].isActive,
                        name: data.settings.slots[j]?.name,
                    })
                }
            }
        }
    }
    return timeslots
}

export async function getTimeSlotsByDate(date: string, isWaitlist?: boolean): Promise<ITimeSlot[]> {
    const facilityId = await getProductId()
    const vacancies = await getVacancies(facilityId, date)

    let activities = store.getters.activities

    if (!activities || activities.length === 0) {
        await store.dispatch('loadActivities')
        activities = store.getters.activities
    }
    const data = activities[0]
    let isAllDayTicket = false

    //checking if it is an all day ticket
    const currentDay = (dayjs(date)).day()
    const slots = data.settings.slots.filter((slot: IFacilitySlot) => {
        if (currentDay === 0) {
            return slot.day === 7
        } else {
            return slot.day === currentDay
        }
    })
    for (const slot of slots) {
        if (slot.start === '0000' && slot.end === '0000') {
            isAllDayTicket = true
            break
        }
    }

    const timeslots: ITimeSlot[] = []

    const name: string = data.name
    const today = new Date()
    const dayOfWeek = currentDay === 0 ? 7 : currentDay

    if (date === today.toISOString().slice(0, 10) && !isAllDayTicket) {
        for (let j = 0; j < data.settings.slots.length; j++) {
            let capacity = ''
            if (data.settings.slots[j].capacity.length === 0) {
                capacity = data.settings.slotCapacity
            } else {
                const capacityHistory = data.settings.slots[j].capacity
                capacity = capacityHistory[capacityHistory.length - 1].capacity
            }

            let vacancy = 0
            for (const vac of vacancies) {
                if (data.settings.slots[j]._id === vac._idSlot) {
                    vacancy = vac.maxPax
                }
            }
            if (vacancy !== 0) {
                timeslots.push({
                    facilityName: name,
                    facilityId: facilityId,
                    slotId: data.settings.slots[j]._id,
                    start: data.settings.slots[j].start,
                    end: data.settings.slots[j].end,
                    maxCapacity: capacity,
                    vacancies: vacancy,
                    isActive: data.settings.slots[j].isActive,
                    name: data.settings.slots[j]?.name,
                })
            } else if (isWaitlist && data.settings.slots[j].day === dayOfWeek) {
                timeslots.push({
                    facilityName: name,
                    facilityId: facilityId,
                    slotId: data.settings.slots[j]._id,
                    start: data.settings.slots[j].start,
                    end: data.settings.slots[j].end,
                    maxCapacity: capacity,
                    vacancies: 0,
                    isActive: data.settings.slots[j].isActive,
                    name: data.settings.slots[j]?.name,
                })
            }
        }
    } else {
        for (let j = 0; j < data.settings.slots.length; j++) {
            let capacity = ''
            if (data.settings.slots[j].capacity.length === 0) {
                capacity = data.settings.slotCapacity
            } else {
                const capacityHistory = data.settings.slots[j].capacity
                capacity = capacityHistory[capacityHistory.length - 1].capacity
            }

            let vacancy = 0
            for (const vac of vacancies) {
                if (data.settings.slots[j]._id === vac._idSlot) {
                    vacancy = vac.maxPax
                    timeslots.push({
                        facilityName: name,
                        facilityId: facilityId,
                        slotId: data.settings.slots[j]._id,
                        start: data.settings.slots[j].start,
                        end: data.settings.slots[j].end,
                        maxCapacity: capacity,
                        vacancies: vacancy,
                        isActive:data.settings.slots[j].isActive,
                        name: data.settings.slots[j]?.name,
                    })
                }
            }
            if (isWaitlist && vacancy === 0 && data.settings.slots[j].day === dayOfWeek) {
                timeslots.push({
                    facilityName: name,
                    facilityId: facilityId,
                    slotId: data.settings.slots[j]._id,
                    start: data.settings.slots[j].start,
                    end: data.settings.slots[j].end,
                    maxCapacity: capacity,
                    vacancies: 0,
                    isActive: data.settings.slots[j].isActive,
                    name: data.settings.slots[j]?.name,
                })
            }
        }
    }
    return timeslots
}

export async function getMaxPaxPerBooking(): Promise<{ maxPaxPerBooking: number, slotCapacity: number }> {
    let activities = store.getters.activities

    if (!activities || activities.length === 0) {
        await store.dispatch('loadActivities')
        activities = store.getters.activities
    }
    
    const maxCapacity = {
        maxPaxPerBooking: result<number>(activities[0], 'maxPaxPerBooking'),
        slotCapacity: result<number>(activities[0], 'settings.slotCapacity')
    }
    return maxCapacity
}

export async function getRestrictedDateRange(): Promise<number> {
    let activities = store.getters.activities

    if (!activities || activities.length === 0) {
        await store.dispatch('loadActivities')
        activities = store.getters.activities
    }

    return result(activities[0], 'restrictedDateRange')
}

export async function holdBooking(payload: IHoldBooking): Promise<IBookingConfirmation> {
    const { data } = await axios({
        method: 'post',
        url: '/integrations/facilities/bookings/hold',
        headers: {
            'api-key': store.getters.apiKey
        },
        data: payload
    })
    return data
}

export async function holdBookings(payload: IHoldBookings): Promise<IBookingConfirmation> {
    const { data } = await axios({
        method: 'post',
        url: '/integrations/facilities/bookings/holds',
        headers: {
            'api-key': store.getters.apiKey
        },
        data: payload
    })
    return data
}

export interface IAllowedDatesResult {
    allowedDates: string[];
    sellingFast: string[];
    slotType: string;
    enoughPax: string[];
    waitlistDates: string[];
}

export async function getAllowedDates(name: string, datePeriod: string, pax: number, isWaitlist?: boolean): Promise<IAllowedDatesResult> {
    const params: IGetAllowedDates = {
        name,
        datePeriod,
        pax,
        ...(isWaitlist ? { isWaitlist: true } : {}),
    }
    const { data } = await axios.get('/integrations/facilities/allowed-dates', {
        headers: {
            'api-key': store.getters.apiKey
        },
        params,
    })

    return {
        ...data,
        waitlistDates: data.waitlistDates ?? [],
    }
}

export async function deleteBooking(bookingId: string): Promise<void> {
    await axios({
        method: 'delete',
        url: `/integrations/facilities/bookings/${bookingId}`,
        headers: {
            'api-key': store.getters.apiKey
        }
    })
}

export async function getHoldAt(id: string): Promise<string> {
    const { data } = await axios({
        method: 'get',
        url: `/integrations/facilities/bookings/${id}/status`,
        headers: {
            'api-key': store.getters.apiKey
        },
    })

    return data
}

export async function getSlotCapacities(): Promise<ICapacity[]> {
    let activities: IFacility[] = store.getters.activities
    let capacities: ICapacity[] = []
    
    if (!activities || activities.length === 0) {
        await store.dispatch('loadActivities')
        activities = store.getters.activities
    }
    const activity = activities[0]

    for (const slot of activity.settings.slots) {
        if (slot.capacity) {
            // sort desc by affectedDate, then by createdDate if affectedDate is the same
            const slotCapacities = slot.capacity.sort((a, b) => {
                const affectedDateDiff = dayjs(b.affectedDate).unix() - dayjs(a.affectedDate).unix()
                return affectedDateDiff !== 0 ? affectedDateDiff : dayjs(b.createdDate).unix() - dayjs(a.createdDate).unix()
            })
            if (slotCapacities.length > 0) {
                capacities.push(slotCapacities[0])
            }
        }
    }
    // sort desc by affectedDate, then by createdDate if affectedDate is the same
    capacities = capacities.sort((a, b) => {
        const affectedDateDiff = dayjs(b.affectedDate).unix() - dayjs(a.affectedDate).unix()
        return affectedDateDiff !== 0 ? affectedDateDiff : dayjs(b.createdDate).unix() - dayjs(a.createdDate).unix()
    })
    return capacities.filter(capacity => capacity.capacity !== 0)
}

export async function getHighestSlotCapacity(): Promise<ICapacity | null> {
    const slotCapacities = await getSlotCapacities()

    if (slotCapacities.length === 0) {
        return null
    }
    
    // Sort slot capacities in descending order
    const sortedSlotCapacities = slotCapacities.sort((a, b) => {
        return b.capacity - a.capacity
    })

    const highestSlotCapacity = sortedSlotCapacities.length > 0 ? sortedSlotCapacities[0] : null

    return highestSlotCapacity
}

export async function isHaveCapacity(payload?: { activities: IFacility[] }): Promise<boolean> {
    let activities: IFacility[] = payload?.activities ?? store.getters.activities

    if (!activities || activities.length === 0) {
        await store.dispatch('loadActivities')
        activities = store.getters.activities
    }

    if (!Array.isArray(activities) || typeof activities[0] !== 'object' || activities.length === 0) {
        console.error('Unexpected or empty activities response:', activities)
        return false
    }

    return true
}
